import { LoaderModal } from '../../../components/UI/NewLoader/LoaderModal/LoaderModal';
import React, { useState } from 'react';

interface IPreviewFrameProps {
    name: string;
    iFrameSrc: string;
    previewUrl: string;
}

export const PreviewFrame = ({ name, iFrameSrc, previewUrl }: IPreviewFrameProps) => {
    const [isLoadingIframe, setIsLoadingIframe] = useState(true);

    return (
        <>
            {isLoadingIframe && <LoaderModal />}

            <iframe
                title={name}
                src={`${iFrameSrc}${previewUrl}`}
                width="720"
                height={window.innerHeight - 132}
                style={{ border: 'none', marginTop: '90px' }}
                onLoad={() => setIsLoadingIframe(false)}
                onError={() => console.log('error')}
            />
        </>
    );
};
